import { TableColumnGroups } from "~/constants/tableColumnGroups"

export enum POSpecificColumnGroups {
  OrderQuantities = "Order Quantities",
  MOQAndConstraints = "MOQ and Constraints",
  Actions = "Actions",
}

export const POColumnGroups = { ...TableColumnGroups, ...POSpecificColumnGroups }
export type POColumnGroups = (typeof POColumnGroups)[keyof typeof POColumnGroups]

export enum PurchaseOrderTableColumn {
  Grouping = "grouping",
  SecondaryMoqGrouper = "secondaryMoqGrouper",

  SKU = "skuId",
  Comments = "comments",
  Quantity = "quantity",
  SuggestedOrder = "suggestedOrderRawQuantity",
  MoqSuggestedOrder = "moqSuggestedOrderQuantity",

  SecondaryMOQ = "secondaryMoq",

  Forecast = "forecastsPurchasePeriod",
  ForecastWithoutPreOrders = "forecastsPurchasePeriodWithoutPreOrders",
  PreOrders = "preordersPurchasePeriod",
  ProjectedWeeksOnHand = "projectedWeeksOnHand",
  ProjectedStock = "projectedStock",
  ProjectedStockEAD = "projectedStockAtExpectedArrivalDate",
  IncomingStockBeforeEAD = "incomingStockBeforeEAD",
  IncomingStockPostPeriod = "incomingStockPostPeriod",

  SizeSplit = "sizeSplit",

  TotalPrice = "totalPrice",
  VendorCurrency = "vendorCurrency",
  PurchasePriceVC = "purchasePriceVc",
  TotalPurchasePriceVC = "totalPurchasePriceVc",
  TotalPurchasePriceLC = "totalPurchasePriceLc",
  SafetyStock = "safetyStock",
  LocationMinimumStockLevel = "locationMinimumStockLevel",

  Actions = "actions",
  PreOrdersBeforeEAD = "preordersBeforeEAD",
  UnfulfillableBeforeEAD = "unfulfillableBeforeEAD",
  AtRiskBeforeEAD = "atRiskBeforeEAD",
  ProjectedLostSalesInPeriod = "projectedLostSalesInPeriod",
  AdjustedLostSalesInPeriod = "adjustedLostSalesInPeriod",
  ImpactWoH = "impactWeeksOnHand",

  MonthCover = "monthCover",
  MonthCoverWithPO = "monthCoverWithPO",
  MonthCoverWithPOMinusLeadtime = "monthCoverWithPOMinusLeadtime",
}
